import Loader from "react-loader-spinner";
import React, { Component } from "react";
import { Colors } from 'config/StyleConfig'

export default class DRLoader extends Component{
    render(){
        return <Loader type="TailSpin" color={Colors.primary} height="50" width="50"/>
    }
}